import React from 'react';
import {Modal, SecondaryButton, TertiaryButton} from 'components';

const ConfirmModal = ({
  onClick,
  isLoading,
  open,
  setOpen,
  buttonText,
  modalTitle,
  modalBody,
}) => (
  <Modal
    show={open}
    modalTitle={modalTitle}
    onClose={() => setOpen(false)}
    extraModalClasses="max-w-[512px] overflow-y-auto h-fit max-h-[95%] sm:max-h-full rounded-b-none sm:rounded-b-lg absolute bottom-0 sm:relative lookup-modal"
    modalPosition="justify-center sm:justify-end"
  >
    <div className="mt-4 px-6">
      <p className="text-start text-sm text-body font-medium">{modalBody}</p>
    </div>

    <div className="w-full mt-6 px-6 py-[14px] border-[0.5px] flex gap-4 border-transparent border-t-[#EFEFEF]">
      <SecondaryButton
        className="w-[50%] !h-10"
        onClick={() => setOpen(false)}
        buttonText="Cancel"
      />
      <TertiaryButton
        onClick={async () => {
          await onClick();
          setOpen(false);
        }}
        buttonText={buttonText}
        className="w-[50%] !h-10 bg-danger"
        loading={isLoading}
        disabled={isLoading}
      />
    </div>
  </Modal>
);

export {ConfirmModal};
